<template>
  <div>
    <div class="filter-box flex-wrap">
      <v-select-store
        class="table-filter-select"
        v-model="store_ids"
        :clearable="true"
        :has-private="true"
        :multiple="true"
        :collapse="true"
        @input="handlePageChange"
        size="small"
        placeholder="门店"
      />
      <v-select-reserve-state
        class="table-filter-select"
        v-model="reserve_state"
        @input="handlePageChange"
        size="small"
        placeholder="预约状态"
      />
      <v-tab-quick-time
        v-model="timeLimit"
        :picker-options="pickerOptionsOfAfterBeforeToday"
        :is-show-next-week="true"
        :is-show-last-thirty-day="true"
        @input="handlePageChange"
        size="small"
      />

      <el-button
        class="table-filter-item"
        v-if="count"
        @click="exportAllExcel"
        size="small"
        plain
        :loading="isExporting"
      >
        导出全部至 Excel{{ isExporting ? `（${Math.min(currentExportPage * 30, count)} / ${count}）` : ''}}
      </el-button>
    </div>

    <template v-if="count">
      <div v-if="limit_days" class="alert-box success-alert">
        每周频率：<b>{{ decimalPlaces(count / limit_days * 7) }}</b> 次
      </div>
      <div v-for="item in list" :key="`reservationRecord${item.id}`" class="item-box">
        <div class="icon-box">
          <v-icon :name="getReservationIconByState(item.reserve_state)"/>
        </div>
        <div class="item-content border-bottom">
          <div class="record-list-item flex-justify-between">
            <div
              v-if="item.reserve_state === reserveStates.signedIn.value && !item.card_id && !item.card_ticket_id && !item.we_chat_order_id"
              class="record-list-title"
            >
              试课
            </div>
            <div v-else class="record-list-title">
              {{ getReservationNameByState(item.reserve_state) }}
            </div>
            <div class="time accent-color">{{ item.add_time | timeToYmdHi }}</div>
          </div>
          <div class="record-list-item">
            课程：「<router-link class="primary-color" :to="RouteConfig.courseManage.to(item.course_id)">{{ item.course_name }}</router-link>」；

            <template v-if="item.course_column_id">
              专栏：「<router-link :to="RouteConfig.courseColumnManage.to(item.course_column_id)" class="primary-color">{{ item.course_column_name }}</router-link>」；
            </template>

            课程时间：「 <span class="success-color">{{ item.start_time | timeToYmdHi }} ~ {{ item.end_time | timeToHi}}</span>」；

            老师：「<span class="success-color">{{ item.teacher_names }}</span>」；

            <template v-if="item.we_chat_order_id">
              商户订单号：「<router-link :to="RouteConfig.weChatOrderList.to('', { keyword: item.out_trade_no })" class="primary-color">{{ item.out_trade_no }}</router-link>」；
              订单原价：「<span class="success-color">{{ item.total | toYuan }}</span> 元」；
              <template v-if="item.reserve_state === reserveStates.signedIn.value">
                实际支付金额：「{{ item.payer_total | toYuan }}」元；
              </template>
            </template>
            <template v-else>
              <template v-if="item.card_id">
                使用课卡：「<router-link :to="RouteConfig.cardDetail.to(item.card_id)" class="primary-color">{{ item.card_name }} No.{{item.card_id}}</router-link>」；
                <template v-if="item.is_number_limit">
                  <template
                    v-if="item.reserve_state === reserveStates.waitSignIn.value
              || item.reserve_state === reserveStates.signCanceled.value"
                  >
                    <template v-if="item.reserve_state === reserveStates.waitSignIn.value">
                      预约扣次：「<span class="success-color">{{ item.decrement_number | toYuan }}</span> 次」；
                    </template>
                    <template v-else>
                      返还次数：「<span class="success-color">{{ -item.decrement_number | toYuan }}</span> 次」；
                    </template>

                    剩余次数：「<span class="success-color">{{ item.expire_number | toYuan }}</span> 次」；
                  </template>
                </template>
                <template v-else>
                  剩余次数：「<span class="success-color">无限制</span>」；
                  <template v-if="item.decrement_days">
                    <template v-if="item.reserve_state === reserveStates.waitSignIn.value
              || item.reserve_state === reserveStates.signCanceled.value
              || item.reserve_state === reserveStates.signedIn.value">
                      <template v-if="item.reserve_state === reserveStates.signCanceled.value">
                        返还天数：「<span class="success-color">{{ -item.decrement_days | toYuan }}</span> 天」；
                      </template>
                      <template v-else>
                        预约扣天：「<span class="success-color">{{ item.decrement_days | toYuan }}</span> 天」；
                      </template>
                    </template>

                  </template>
                </template>
                <template v-if="item.add_time > 1704038400">
                  过期时间：「<span class="success-color"><template v-if="item.expire_time">{{ item.expire_time | timeToYmdHi }}</template><template v-else>未开卡</template></span>」。
                </template>
              </template>
              <template v-else-if="item.card_ticket_id">
                使用课次券：「<router-link :to="RouteConfig.cardTicketDetail.to(item.card_ticket_id)" class="primary-color">{{ item.card_ticket_type_name }} No.{{item.card_ticket_id}}</router-link>」；
                <template
                  v-if="item.reserve_state === reserveStates.waitSignIn.value
              || item.reserve_state === reserveStates.signCanceled.value"
                >
                  <template v-if="item.reserve_state === reserveStates.waitSignIn.value">
                    预约扣次：「<span class="success-color">{{ item.decrement_number | toYuan }}</span> 次」；
                  </template>
                  <template v-else>
                    返还次数：「<span class="success-color">{{ -item.decrement_number | toYuan }}</span> 次」；
                  </template>

                  剩余次数：「<span class="success-color">{{ item.expire_number | toYuan }}</span> 次」；
                </template>
                过期时间：「<span class="success-color"><template v-if="item.expire_time">{{ item.expire_time | timeToYmdHi }}</template><template v-else>未开卡</template></span>」。
              </template>
              <template v-else>使用课卡：「<span class="success-color">免费预约</span>」。</template>
            </template>
          </div>
          <div class="store-name accent-color">
            <span class="operator">
              操作者：{{ item.administrator_name ? item.administrator_name : '本人' }}
            </span>
            <span v-if="item.add_time > 1767514800" class="operator">
              操作平台：{{ item.is_app ? '小程序' : '后台系统' }}
            </span>
            所属门店：{{ item.store_name }}
          </div>
        </div>
      </div>

      <div class="pagination-box">
        <el-pagination
          :background="true"
          :current-page.sync="page"
          :page-size.sync="size"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="pageSizes"
          :total="count"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>
    <div v-else class="empty-tip-box">暂无预约记录</div>
  </div>
</template>

<script>
import RouteConfig from "@/router/config";
import scrollTo from "@/utils/scroll-to";
import exportExcel from '@/utils/excel-export';
import { pickerOptionsOfAfterBeforeToday } from '@/utils/formats';
import { timeToYmdHi, timeToHi, toYuan, decimalPlaces } from "@/filters";
import { getReservationIconByState, getReservationNameByState, reserveStates } from "@/enums/reserveStates";
import { getCourseReservationRecordsByStudentId } from "@/api/course-reservation";

export default {
  props: {
    studentId: Number,
    studentName: String,
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    reserveState: {
      type: [Number, String],
      default: '',
    },
  },
  data: () => ({
    RouteConfig,
    reserveStates,
    pickerOptionsOfAfterBeforeToday,
    isExporting: false,
    currentExportPage: 0,
    list: [],
    count: 0,
    page: 1,
    size: 10,
    reserve_state: '',
    timeLimit: [],
    store_ids: [],
    pageSizes: [10, 20, 30, 50],
  }),
  computed: {
    start_date() {
      const { timeLimit } = this;
      return timeLimit && timeLimit.length ? timeLimit[0] : '';
    },
    end_date() {
      const { timeLimit } = this;
      return timeLimit && timeLimit.length ? timeLimit[1] : '';
    },
    limit_days() {
      return this.calculateDaysBetween(this.start_date, this.end_date);
    },
  },
  methods: {
    exportExcel,
    getReservationNameByState,
    getReservationIconByState,
    decimalPlaces,
    calculateDaysBetween(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffInMs = Math.abs(endDate - startDate);
      return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    },
    async getList() {
      if (!this.studentId) return;

      const { isError, data } = await getCourseReservationRecordsByStudentId({
        student_id: this.studentId,
        store_ids: this.store_ids,
        reserve_state: this.reserve_state,
        start_date: this.start_date,
        end_date: this.end_date,
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
    },
    getReserveStateName(item) {
      if (item.reserve_state === reserveStates.signedIn.value && !item.card_id && !item.we_chat_order_id) return '试课';

      return getReservationNameByState(item.reserve_state);
    },
    setXlsData(list) {
      let xlsData = [];
      list.forEach(item => {
        xlsData.push({
          '操作': this.getReserveStateName(item),
          '操作时间': timeToYmdHi(item.add_time),
          '操作者': item.administrator_name ? item.administrator_name : '本人',
          '课程': item.course_name,
          '课程专栏': item.course_column_id ? item.course_column_name : '',
          '课程时间': `${timeToYmdHi(item.start_time)} ~ ${timeToHi(item.end_time)}`,
          '老师': item.teacher_names,

          '商户订单号': item.we_chat_order_id ? item.out_trade_no : '',
          '订单原价': item.we_chat_order_id ? toYuan(item.total) : '',
          '实际支付金额': item.we_chat_order_id ? (item.reserve_state === reserveStates.signedIn.value ? toYuan(item.payer_total) : '' ) : '',

          '使用课卡': item.we_chat_order_id ? '' : (item.card_id ? item.card_name : '免费预约'),
          '预约扣次': item.is_number_limit ? toYuan(item.decrement_number) : '',
          '返还次数': (item.reserve_state === reserveStates.signCanceled.value && item.is_number_limit ? toYuan(-item.decrement_number) : '') || '',
          '剩余次数': item.is_number_limit ? toYuan(item.expire_number) : '无限制',
          '所属门店': item.store_name || '',
        });
      });
      return xlsData;
    },
    async exportAllExcel() {
      if (this.isExporting || !this.count) return;

      this.isExporting = true;

      let xlsData = [];
      const maxPage = Math.ceil(this.count / 30);
      for (let i = 0; i < maxPage; i++) {
        this.currentExportPage = i + 1;
        const { isError, data } = await getCourseReservationRecordsByStudentId({
          student_id: this.studentId,
          store_ids: this.store_ids,
          reserve_state: this.reserve_state,
          start_date: this.start_date,
          end_date: this.end_date,
          page: this.currentExportPage,
          size: 30,
          is_only_list: 1,
        });
        if (isError || !data) break;
        xlsData = xlsData.concat(data);
      }

      xlsData = this.setXlsData(xlsData);
      exportExcel(xlsData, `${this.studentName || ''}的预约记录`);
      this.isExporting = false;
    },
    handlePageChange() {
      this.getList();
      scrollTo(0, 350);
    },
  },
  beforeMount() {
    // 支持从学员详情页链接带活动日期与签到状态进入
    this.timeLimit = this.startDate && this.endDate ? [this.startDate, this.endDate] : [];
    this.reserve_state = this.reserveState || '';
    this.getList();
  },
};
</script>

<style src="@/components/student-detail-record.css" scoped/>
